var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavHeartBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1205 4674 c-589 -91 -1048 -525 -1177 -1112 -32 -142 -31 -413 1 -562 32 -150 63 -237 136 -385 107 -216 239 -374 585 -699 353 -332 739 -669 1335 -1164 187 -156 353 -291 369 -299 41 -21 135 -28 181 -13 40 13 82 46 435 339 753 627 1378 1188 1609 1444 138 154 211 257 282 402 66 135 100 233 131 379 29 136 32 409 5 536 -93 444 -367 805 -759 999 -385 190 -824 201 -1216 29 -172 -75 -293 -161 -464 -327 l-98 -94 -107 104 c-164 159 -294 249 -470 324 -234 101 -527 138 -778 99z m376 -450 c148 -26 272 -75 394 -157 33 -23 150 -129 260 -237 151 -149 210 -200 240 -211 56 -18 143 -16 185 6 19 9 121 102 225 204 105 103 220 209 257 234 88 63 199 113 317 144 82 22 117 26 241 26 125 0 159 -4 245 -27 461 -122 762 -552 714 -1019 -19 -189 -94 -381 -207 -533 -101 -136 -396 -425 -792 -774 -381 -336 -1083 -930 -1100 -930 -5 0 -123 95 -262 212 -874 731 -1471 1277 -1627 1487 -178 240 -250 533 -200 811 92 506 595 852 1110 764z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHeartBlack);
export default __webpack_public_path__ + "static/media/navHeartBlack.738c5e3a03f1153e4bd3cbe2b3d7c1b5.svg";
export { ForwardRef as ReactComponent };